import { render, staticRenderFns } from "./ScheduleItem.vue?vue&type=template&id=497211e2&"
import script from "./ScheduleItem.vue?vue&type=script&lang=js&"
export * from "./ScheduleItem.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleItem.vue?vue&type=style&index=0&id=497211e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports